import React, { Fragment } from 'react';
import { SvgIcon, SvgIconProps } from '../components';

export default function FullscreenTwoTone(props: SvgIconProps) {
  return (
    <SvgIcon {...props}>
      <Fragment>
        <path d="M5,5H10V7H7V10H5V5M14,5H19V10H17V7H14V5M17,14H19V19H14V17H17V14M10,17V19H5V14H7V17H10Z" />{' '}
      </Fragment>
    </SvgIcon>
  );
}
